//TODO: Type this better
export function getByPath(path: string, object: Record<string, any>) {
  return path.split('.').reduce((o, i) => (o ? o[i] : undefined), object);
}
